import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-success-rate-donut',
  templateUrl: './success-rate-donut.component.html',
  styleUrls: ['./success-rate-donut.component.scss']
})
export class SuccessRateDonutComponent {
  radius = 12;

  @Input()
  color: any;
  @Input()
  percentage: any;
  @Input()
  title: string;

  x = 25;
  y = 20;

  constructor() { }

  getStrokeDasharray(): string {
    const circumference = this.radius * 2 * Math.PI;

    const percentage = this.percentage ? this.percentage : 0;

    return `${percentage * circumference / 100} ${circumference}`;
  }

  getCirclePath() {
    return `M ${this.x}, ${this.y - this.radius}
    a ${this.radius},${this.radius} 0 1,1 0,${this.radius * 2}
    a ${this.radius},${this.radius} 0 1,1 0,-${this.radius * 2}`;
  }
}
